import {IsBoolean, IsOptional} from 'class-validator';

export class NotificationReadAllDto {
  @IsOptional()
  @IsBoolean()
  isCustom?: boolean | null;
}
